<template>
  <b-container class="highlight-container">

    <router-link to="/"><i class="fas fa-times btn--close"></i></router-link>

    <b-row>
      <b-col md="12" class="text-center px-0">
        <h1 v-scroll-reveal>New Schools <br>Right in Your <br>Neighbourhood </h1>
        <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/schools-highlight-banner.png" fluid center alt="New Seaton New Schools"/>
        </div>
      </b-col>
    </b-row>

    <b-row class="background--white">
      <b-col md="10" offset-md="1" class="text-center">
         <h3 class="text--red text--extrabold mb-25"><a data-fancybox="video" href="https://player.vimeo.com/video/359571608?title=0&byline=0&portrait=0&transparent=0">WATCH VIDEO</a></h3>
        <p v-scroll-reveal>
          For most families, mornings can be the most hectic time of the day. Between getting the <br class="d-none d-xl-block">kids
          out of bed,
          dressed and fed, and getting yourself ready for work, it can often feel like <br class="d-none d-xl-block">you're
          racing against the clock.
        </p>
        <p v-scroll-reveal>Luckily the New Seaton community has been designed to make your mornings a
          little more relaxed. <br class="d-none d-xl-block">All new primary schools are proposed to be built right in
          your New Seaton neighbourhood.
          This means it will be a <br class="d-none d-xl-block">little easier to drop your kids off on the way to work,
          or even have them walk themselves.
        </p>
        <highlight-footer slot="register" />
      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
  import highlightFooter from '@/components/HighlightFooter';
  export default {
    components: {
      highlightFooter
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation()
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }

</script>

<style scoped>

</style>
